import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';

const keywords = ['TERRA', 'company information', '会社概要'];

const Company = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>会社概要｜株式会社TERRA</title>
      </Helmet>
      <div className="company">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          会社概要
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>会社概要</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2">
                <table className="table borderless" style={{ color: 'rgb(44,81,115)' }}>
                  <tbody>
                    <tr>
                      <th style={{ borderTop: 'none', width: '30%' }}>会社名</th>
                      <td style={{ borderTop: 'none', width: '70%' }}>株式会社 TERRA</td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>所在地</th>
                      <td style={{ width: '70%' }}>
                        〒107-0051
                        <br />
                        東京都港区元赤坂 1-7-18
                        <br />
                        メットライフ元赤坂イースト 7F
                        <br />
                        <br />
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe
                          className="d-none d-lg-block"
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.946669106687!2d139.73033611605882!3d35.678315137737734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c7d8d22d34b%3A0x641bf97c6d94f50e!2z5pel5pys44CB44CSMTA3LTAwNTEg5p2x5Lqs6YO95riv5Yy65YWD6LWk5Z2C77yR5LiB55uu77yX4oiS77yR77yY!5e0!3m2!1sja!2s!4v1622097534127!5m2!1sja!2s"
                          style={{
                            height: '350px',
                            width: '100%',
                          }}
                          frameBorder="0"
                          allowFullScreen=""
                          aria-hidden="false"
                        />
                      </td>
                    </tr>
                    <tr className="d-lg-none">
                      <td colSpan="2">
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.946669106687!2d139.73033611605882!3d35.678315137737734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c7d8d22d34b%3A0x641bf97c6d94f50e!2z5pel5pys44CB44CSMTA3LTAwNTEg5p2x5Lqs6YO95riv5Yy65YWD6LWk5Z2C77yR5LiB55uu77yX4oiS77yR77yY!5e0!3m2!1sja!2s!4v1622097534127!5m2!1sja!2s"
                          style={{
                            width: '100%',
                          }}
                          frameBorder="0"
                          allowFullScreen=""
                          aria-hidden="false"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>連絡先</th>
                      <td style={{ width: '70%' }}>
                        TEL 03-6812-9104
                        <br />
                        FAX 03-6812-9105
                      </td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>代表取締役</th>
                      <td style={{ width: '70%' }}>廣川 正秋</td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>事業内容</th>
                      <td style={{ width: '70%' }}>
                        空間除菌剤「TERRA　FORESTA」の製造・販売
                        <br />
                        光触媒コーティング「TERRA COAT」の製造・施工業務
                      </td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>資本金</th>
                      <td style={{ width: '70%' }}>2000 万円</td>
                    </tr>
                    <tr>
                      <th style={{ width: '30%' }}>設立日</th>
                      <td style={{ width: '70%' }}>2021 年 2 月</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Company;
